import { url as cmsUrl } from 'aldoo-ra/CMS/url'

const FONT = "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif"

const CURRENCY_SYMBOLS = {
  USD: '$', EUR: '€', GBP: '£', JPY: '¥',
  CAD: 'CA$', AUD: 'A$', CHF: 'CHF', SEK: 'kr',
  NOK: 'kr', DKK: 'kr', PLN: 'zł', CZK: 'Kč',
  BGN: 'лв',
}

function formatPrice(price, currency) {
  if (!price || Number(price) <= 0) return null
  const code = (currency || 'USD').toUpperCase()
  const sym = CURRENCY_SYMBOLS[code] || code + ' '
  return `${sym}${Number(price).toFixed(2)}`
}

export default function StoreProductCard({ pid, name, price, currency, thumbnail, inverted }) {
  const displayPrice = formatPrice(price, currency)
  const textColor = inverted ? 'rgba(255,255,255,0.95)' : '#1a1a2e'
  const priceColor = inverted ? 'rgba(255,255,255,0.75)' : '#6366f1'
  const iconBg = inverted
    ? 'rgba(255,255,255,0.2)'
    : 'linear-gradient(135deg, #6366f1 0%, #10b981 100%)'

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      gap: 10,
      padding: '10px 14px',
      fontFamily: FONT,
    }}>
      {/* Thumbnail or icon placeholder */}
      <div style={{
        width: 38,
        height: 38,
        borderRadius: 8,
        overflow: 'hidden',
        flexShrink: 0,
        background: iconBg,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}>
        {thumbnail ? (
          <img src={cmsUrl(thumbnail)} alt={name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
        ) : (
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
            <path d="M20 7H4a1 1 0 00-1 1v10a1 1 0 001 1h16a1 1 0 001-1V8a1 1 0 00-1-1z" stroke="white" strokeWidth="1.8" strokeLinecap="round"/>
            <path d="M16 7V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v2" stroke="white" strokeWidth="1.8" strokeLinecap="round"/>
          </svg>
        )}
      </div>

      {/* Name + price */}
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{
          fontSize: 13,
          fontWeight: 600,
          color: textColor,
          fontFamily: FONT,
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}>
          {name || pid}
        </div>
        {displayPrice && (
          <div style={{
            fontSize: 12,
            color: priceColor,
            fontWeight: 600,
            fontFamily: FONT,
            marginTop: 1,
          }}>
            {displayPrice}
          </div>
        )}
      </div>

      {/* Add to cart arrow */}
      {inverted && (
        <span style={{ color: 'rgba(255,255,255,0.8)', fontSize: 18, lineHeight: 1, flexShrink: 0 }}>›</span>
      )}
    </div>
  )
}
